export const GET_LOTS = 'lots/GET_LOTS';
export const GET_LOTS_SUCCESS = 'lots/GET_LOTS_SUCCESS';
export const GET_LOTS_FAILED = 'lots/GET_LOTS_FAILED';